module.exports = __webpack_public_path__ + "img/fpa.f58e2f36.png";